/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UnlockIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2UnlockIcon from 'DesignSystem/Svgs/Tysiav2UnlockIcon/index'



/** @type {import('Simple/types.js').View} */
export default function UnlockIcon({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/DownpaymentAmount/LockAction/Icon/UnlockIcon"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<Tysiav2UnlockIcon
  viewPath={`${viewPath}/Tysiav2UnlockIcon`}
 fill2={dtColorsNeutral500}
 height={dtSpaceL}
 width={dtSpaceL}
/>
{children}
</React.Fragment>)
}